export const formatPesos = (num: number) => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export const formatCurrency = (num: number) => {
  return `$ ${num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`
}
